module.exports = __webpack_public_path__ + "media/images/leader-3-7a4264977ea6a19dd976b548d7448a69.svg";